var scope_0 = require('/tmp/3173ef8c/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d1b6e7b9eac70fd7a2bba9f9c500fe05.js').default;export default
        Object.assign({}, scope_0 )
    